import { camelizeKeys } from 'humps';
import { get } from '@namespace/helpers';

export const getPopularBetsEvents = ({ sportId, lang }) =>
  get(`/service/lineout/${lang}/frontend_api/top/${sportId}`).then(
    camelizeKeys
  );
